import Product from '@src/quince-site-common/src/domains/Product'
import { IProductPurchaseInfo } from '@src/quince-site-common/src/domains/ProductPurchaseInfo'
import { BaseProductVariant, ProductVariantOption } from '@src/quince-site-common/src/domains/ProductVariant'

export enum BUNDLE_PRODUCT_TYPE {
  DEFAULT = 'DEFAULT',
  OPTIONAL = 'OPTIONAL',
  SIBLING = 'SIBLING',
}

export interface BundleConfig {
  products: BundleProductConfig[]
  optionalProducts: BundleProductConfig[]
}

export interface BundleProductConfig {
  type: BUNDLE_PRODUCT_TYPE
  product: Product
  selection: {
    isSelected: boolean
  }
  selectedOptions: ProductVariantOption[]
  variants: BaseProductVariant[]
  purchaseInfo?: IProductPurchaseInfo | null
  error: string | null
  salePrice: number
  traditionalPrice: number
}

export enum BundleActionType {
  UPDATE_SELECTED_OPTIONS = 'UPDATE_SELECTED_OPTIONS',
  UPDATE_SIBLING_SELECTED_OPTIONS = 'UPDATE_SIBLING_SELECTED_OPTIONS',
  UPDATE_SELECTION = 'UPDATE_SELECTION',
  UPDATE_PRICING_INFO_FOR_ALL = 'UPDATE_PRICING_INFO_FOR_ALL',
}

interface UpdateSelectedOptions {
  type: BundleActionType.UPDATE_SELECTED_OPTIONS
  payload: { index: number; optionName: string; optionValue: string; isOptional: boolean }
}

interface UpdateSiblingSelectedOptions {
  type: BundleActionType.UPDATE_SIBLING_SELECTED_OPTIONS
  payload: {
    index: number
    product: Product
    purchaseInfo?: IProductPurchaseInfo
    isOptional: boolean
    searchParams?: string
  }
}

interface UpdateSelection {
  type: BundleActionType.UPDATE_SELECTION
  payload: { index: number; checked: boolean }
}

interface UpdatePricingInfoForAllProducts {
  type: BundleActionType.UPDATE_PRICING_INFO_FOR_ALL
  payload: {
    purchaseInfo: Record<number, IProductPurchaseInfo>
  }
}

export type BundleAction =
  | UpdateSelectedOptions
  | UpdateSiblingSelectedOptions
  | UpdateSelection
  | UpdatePricingInfoForAllProducts
